import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes.jsx";
import AuthProtected from "./AuthProtected.jsx";

// Import layouts
import NonAuthLayout from "../Layouts/NonAuthLayout.jsx";
import VerticalLayout from "../Layouts/VerticalLayouts/index.jsx";

const Index = () => {
  console.log("🚀 Index component is rendering!");
  
  return (
    <React.Fragment>
    <Routes>
        {/* Public routes */}
        {publicRoutes.map((route, idx) => {
          const Component = route.component;
          return (
            <Route
              path={route.path}
              element={
                route.path === "/" ? (
                  // Landing page doesn't need NonAuthLayout
                  <Component />
                ) : (
                  <NonAuthLayout>
                    <Component />
                  </NonAuthLayout>
                )
              }
              key={idx}
            />
          );
        })}

        {/* Protected routes */}
        {authProtectedRoutes.map((route, idx) => {
          const Component = route.component;
          return (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>
                    <Component />
                  </VerticalLayout>
                </AuthProtected>
              }
              key={idx}
            />
          );
        })}

        {/* Catch all route - redirect to login page */}
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />
    </Routes>
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
};

export default Index;
